import React, { useEffect, useState } from "react";
import Input from "../shared/Input";
import topTost from "../../utils/topTost";
import { useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import { IBaseUrl } from "../..";
import Swal from "sweetalert2";

const PrefixContent = (permission) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [prefixformData, setprefixFormData] = useState({
    id: "1",
    task_prefix: "",
    loan_prefix: "",
    user_prefix: "",
    expense_prefix: "",
    notes_prefix: "",
  });
  const handleChange = (name, value) => {
    setprefixFormData({ ...prefixformData, [name]: value });
  };

  const fetchDetails = async () => {
    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const formData = new FormData();
      formData.append("id", 1);

      const result = await fetchFormData("get-prefix-by-id", formData, "POST");

      if (result && result.data) {
        setprefixFormData(result.data);
      } else {
        console.warn("data not found.");
        setprefixFormData({});
      }
    } catch (error) {
      console.error("Failed to fetch:", error);
      setprefixFormData({});
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("moduleId", M_id);
      formData.append("task_prefix", prefixformData.task_prefix);
      formData.append("loan_prefix", prefixformData.loan_prefix);
      formData.append("user_prefix", prefixformData.user_prefix);
      formData.append("expense_prefix", prefixformData.expense_prefix);
      formData.append("notes_prefix", prefixformData.notes_prefix);
      formData.append("id", 1);
      const result = await fetchFormData("update-prefix", formData);
      if (result.success || result.code === 200) {
        topTost({
          title: result.message,
          icon: "success",
        });
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      console.error("Error updating company profile:", error);
      topTost({ title: "Failed to update profile", icon: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="col-lg-12">
      <div className="card stretch stretch-full">
        <hr className="mt-0" />
        <div className="card-body general-info">
          <div className="mb-5 d-flex align-items-center justify-content-between">
            <h5 className="fw-bold mb-0 me-4">
              <span className="d-block mb-2">Prefix Settings</span>
            </h5>
          </div>

          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-4">
              <Input
                label="Task Prefix"
                name="task_prefix"
                value={prefixformData.task_prefix}
                onChange={handleChange}
                icon="feather-hash"
                required
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Loan Prefix"
                name="loan_prefix"
                value={prefixformData.loan_prefix}
                onChange={handleChange}
                icon="feather-hash"
                required
              />
            </div>
            <div className="col-md-4">
              <Input
                label="User Prefix"
                name="user_prefix"
                value={prefixformData.user_prefix}
                onChange={handleChange}
                icon="feather-user"
                required
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Expense Prefix"
                name="expense_prefix"
                value={prefixformData.expense_prefix}
                onChange={handleChange}
                icon="feather-dollar-sign"
                required
              />
            </div>
            <div className="col-md-4">
              <Input
                label="Notes Prefix"
                name="notes_prefix"
                value={prefixformData.notes_prefix}
                onChange={handleChange}
                icon="feather-file"
                required
              />
            </div>

            <div className="customButton mt-4">
              <button
                type="submit"
                className="btn btn-lg btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default PrefixContent;
